import { immerOn } from 'ngrx-immer/store';
import { availableRadiusOptions } from './radius.state';
import {
  resetRadiusFilter,
  setRadiusFilter,
  setRadiusFilterBasedOnUrlValue,
} from './radius.actions';
import { resetAllFilters } from '../filter.actions';
import {
  FilterState,
  RadiusFilterOption,
  RadiusFilterState,
} from '@immosky/types';

export const initialRadiusState: RadiusFilterState = {
  filter: availableRadiusOptions[0],
  default: availableRadiusOptions[0],
  isActive: false,
};

export const radiusReducers = [
  immerOn(setRadiusFilter, (state: FilterState, { filter }) => {
    updateRadiusFilter(state, filter);
  }),
  immerOn(resetRadiusFilter, resetAllFilters, (state: FilterState) => {
    updateRadiusFilter(state, state.radius.default);
  }),
  immerOn(setRadiusFilterBasedOnUrlValue, (state: FilterState, { value }) => {
    const option = availableRadiusOptions.find((o) => o.value === value);

    if (option) {
      state.radius.filter = option;
    }

    state.radius.isActive = isRadiusFilterActive(
      state.radius.filter,
      state.radius.default
    );
  }),
];

export function updateRadiusFilter(
  state: FilterState,
  filter: RadiusFilterOption
) {
  state.radius.filter = filter;
  state.radius.isActive = isRadiusFilterActive(
    state.radius.filter,
    state.radius.default
  );
}

export function isRadiusFilterActive(
  currentOption: RadiusFilterOption,
  defaultOption: RadiusFilterOption
): boolean {
  return currentOption.id !== defaultOption.id;
}
